function getAlertPollingInterval() {
  return 60000;
}
const alertPollingInterval = getAlertPollingInterval();
module.exports = {
  alertPollingInterval,
};
